import { useState } from "react";
import { HandySvg } from "handy-svg";
import iconBottomArrow from "../../assets/icons/svg-sprite/arrow-bottom.svg";
import ChannelLogo from "../../components/channelLogo/ChannelLogo";
import ChannelLogoWithTooltip from "../../components/channelLogo/ChannelLogoWithTooltip";

const UsefulServices = ({
  subscriptions,
  setSelectedPackages,
  setPackageToDelete,
  connectedPackages,
}) => {
  const [sideChannel, setSideChannel] = useState(subscriptions[0]);
  const period = {
    30: "мес",
    90: "3мес",
    180: "6мес",
    365: "год",
  };

  function changeOfDate(date) {
    return `${date.slice(8, 10)}.${date.slice(5, 7)}.${date.slice(0, 4)}`;
  }

  return (
    <>
      <li className="accordion__list-item">
        <a className="accordion__option" href="#useful-services">
          <div className="accordion__option-inner">
            <h3 className="accordion__option-title">Полезные услуги</h3>
            <div className="accordion__option-icon">
              <HandySvg
                className="svg-icon"
                src={iconBottomArrow}
                width="20"
                height="20"
              />
            </div>
          </div>
        </a>
        <div className="accordion__section" id="useful-services">
          <div className="accordion__section-inner">
            <section className="channel-packs">
              <div className="channel-packs__grid">
                <div className="channel-packs__body">
                  <ul className="channel-packs__channel-list js-channel-pack-list">
                    {subscriptions.map((item) => (
                      <li
                        className={
                          "channel-packs__channel-item" +
                          (item.status === "1" ? " js-theme-enabled" : "") +
                          (connectedPackages.hasOwnProperty(
                            item.billing_service_code
                          )
                            ? " js-theme-enabled"
                            : "")
                        }
                        data-service_code={item.billing_service_code}
                      >
                        <section className="channel-description js-pack-item">
                          <header className="channel-description__header">
                            <span className="channel-description__arrow-indicator js-pack-btn">
                              <HandySvg
                                className="svg-icon"
                                src={iconBottomArrow}
                                width="16"
                                height="16"
                              />
                            </span>
                            <div className="channel-description__title-wrap">
                              <h6
                                className="channel-description__title js-pack-btn"
                                onClick={() => setSideChannel(item)}
                              >
                                {item.name}
                                {item.status === "1" ? (
                                  item.date.start ? (
                                    item.date.unsubscribed ? (
                                      <span class="info-cards__price-list-description">
                                        отключение{" "}
                                        {changeOfDate(item.date.unsubscribed)}
                                      </span>
                                    ) : (
                                      <span class="info-cards__price-list-description">
                                        до {changeOfDate(item.date.end)}
                                      </span>
                                    )
                                  ) : (
                                    <span class="info-cards__price-list-description">
                                      ожидает оплаты
                                    </span>
                                  )
                                ) : (
                                  ""
                                )}
                                {connectedPackages.hasOwnProperty(
                                  item.billing_service_code
                                ) ? (
                                  <span class="info-cards__price-list-description">
                                    заявка на включение
                                  </span>
                                ) : (
                                  ""
                                )}
                              </h6>
                            </div>
                            <div className="channel-description__wrap-price">
                              <span className="channel-description__price channel-description__price--base number number--sm">
                                {item.price.rubles}{" "}
                                <span className="number__units">
                                  Р/{period[item.price.days]}
                                </span>
                              </span>
                            </div>
                            <div className="checkbox channel-description__checkbox">
                              {connectedPackages.hasOwnProperty(
                                item.billing_service_code
                              ) ? (
                                <input
                                  className="checkbox__input"
                                  id={`useful-service_${item.billing_service_code}`}
                                  type="checkbox"
                                  name="channel-package"
                                  value={`useful-service_${item.billing_service_code}`}
                                  checked
                                />
                              ) : item.status === "1" ? (
                                <input
                                  className="checkbox__input"
                                  id={`useful-service_${item.billing_service_code}`}
                                  type="checkbox"
                                  name="channel-package"
                                  value={`useful-service_${item.billing_service_code}`}
                                  checked
                                  onChange={() => {
                                    setPackageToDelete({
                                      billing_service_code:
                                        item.billing_service_code,
                                      name: item.name,
                                      price: item.price,
                                    });
                                  }}
                                />
                              ) : (
                                <input
                                  className="checkbox__input"
                                  id={`useful-service_${item.billing_service_code}`}
                                  type="checkbox"
                                  name="channel-package"
                                  value={`useful-service_${item.billing_service_code}`}
                                  onChange={(e) => {
                                    const f = document.getElementById(
                                      `services_${item.billing_service_code}`
                                    );
                                    if (e.target.checked) {
                                      if (f) f.checked = true;
                                      setSelectedPackages((prevState) => [
                                        ...prevState,
                                        {
                                          billing_service_code:
                                            item.billing_service_code,
                                          name: item.name,
                                          price: item.price,
                                        },
                                      ]);
                                      setSideChannel(item);
                                      if (item.group_id) {
                                        const twinServices =
                                          subscriptions.filter(
                                            (subscription) =>
                                              subscription.group_id ===
                                                item.group_id &&
                                              subscription.billing_service_code !==
                                                item.billing_service_code
                                          );
                                        if (twinServices.length > 0) {
                                          twinServices.forEach((element) => {
                                            const twin =
                                              document.getElementById(
                                                `twin_of_useful_service_${element.billing_service_code}`
                                              );
                                            twin.classList.add(
                                              "js-twin-services"
                                            );
                                          });
                                        }
                                      }
                                    } else {
                                      if (f) f.checked = false;
                                      setSelectedPackages((prevState) =>
                                        prevState.filter(
                                          (elem) =>
                                            elem.billing_service_code !==
                                            item.billing_service_code
                                        )
                                      );
                                      if (item.group_id) {
                                        const twinServices =
                                          subscriptions.filter(
                                            (subscription) =>
                                              subscription.group_id ===
                                                item.group_id &&
                                              subscription.billing_service_code !==
                                                item.billing_service_code
                                          );
                                        if (twinServices.length > 0) {
                                          twinServices.forEach((element) => {
                                            const twin =
                                              document.getElementById(
                                                `twin_of_useful_service_${element.billing_service_code}`
                                              );
                                            twin.classList.remove(
                                              "js-twin-services"
                                            );
                                          });
                                        }
                                      }
                                    }
                                  }}
                                />
                              )}
                              <label
                                id={`twin_of_useful_service_${item.billing_service_code}`}
                                className={
                                  "checkbox__label" +
                                  (item.status !== "1" &&
                                  item.group_id &&
                                  subscriptions.filter(
                                    (subscription) =>
                                      subscription.group_id === item.group_id &&
                                      subscription.status === "1"
                                  ).length > 0
                                    ? " js-twin-services"
                                    : "")
                                }
                                for={`useful-service_${item.billing_service_code}`}
                              ></label>
                            </div>
                          </header>
                          <div class="channel-description__body js-pack-content">
                            <div className="channel-description__pic-wrap">
                              <img
                                className="channel-description__pic"
                                alt={item.name}
                                width="auto"
                                height="auto"
                                src={item.image}
                              />
                            </div>
                            <div className="channel-description__text">
                              <span className="channel-description__text-title title title--h3">
                                {item.name}
                              </span>
                              <p>{item.description}</p>
                            </div>
                            {item.tv_channels && (
                              <div className="channel-description__logos">
                                <span className="channel-description__heading title title--sub">
                                  Телеканалы
                                </span>
                                <ul className="channel-description__logo-list">
                                  {item.tv_channels.map((channel) => (
                                    <ChannelLogo channel={channel} />
                                  ))}
                                </ul>
                              </div>
                            )}
                          </div>
                        </section>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="channel-packs__side">
                  <div className="channel-description__pic-wrap">
                    <img
                      className="channel-description__pic"
                      alt={sideChannel.name}
                      width="auto"
                      height="auto"
                      src={sideChannel.image}
                    />
                  </div>
                  <div className="channel-description__text">
                    <span className="channel-description__text-title title title--h3">
                      {sideChannel.name}
                    </span>
                    <p>{sideChannel.description}</p>
                  </div>
                  {sideChannel.tv_channels && (
                    <div className="channel-description__logos">
                      <span className="channel-description__heading title title--sub">
                        Телеканалы
                      </span>
                      <ul className="channel-description__logo-list">
                        {sideChannel.tv_channels.map((channel) => (
                          <ChannelLogoWithTooltip channel={channel} />
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </section>
          </div>
        </div>
      </li>
    </>
  );
};

export default UsefulServices;
